export default class TutorialOverlayMediatorEvent { }

TutorialOverlayMediatorEvent.REPLAY_BUTTON_CLICKED = "TutorialOverlayMediatorEvent.REPLAY_BUTTON_CLICKED";
TutorialOverlayMediatorEvent.CONTINUE_BUTTON_CLICKED = "TutorialOverlayMediatorEvent.CONTINUE_BUTTON_CLICKED";